import { ApolloQueryResult } from "@apollo/client";
import { CompanyCandidateListQuery, Exact } from "@generated/graphql";
import Button from "@mui/material/Button";
import AddCandidateModal, { AddCandidateModalProps } from "components/AddCandidateModal";
import PageHeader from "components/PageHeader";
import { COMPANY_CANDIDATE_UPLOAD_URL } from "constants/urls";
import useSetTabTitle from "hooks/useSetTabTitle";
import useUploadCandidates from "hooks/useUploadCandidates";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  refetchList: (
    variables?: Partial<Exact<{ [key: string]: never }>>
  ) => Promise<ApolloQueryResult<CompanyCandidateListQuery>>;
}

const Header = ({ refetchList }: HeaderProps) => {
  const navigate = useNavigate();
  const [modalOpened, setModalOpened] = useState(false);
  const title = "Кандидаты";
  const { uploadCandidates, uploadCandidatesLoading } = useUploadCandidates({
    uploadUrl: COMPANY_CANDIDATE_UPLOAD_URL,
  });

  useSetTabTitle(title);

  const onSubmitAddCandidateModal: AddCandidateModalProps["onSubmit"] = async ({ formData }) => {
    if (formData) {
      const res = await uploadCandidates({ ...formData });
      if (res instanceof Response && res.ok) {
        refetchList();
      }
    }
  };

  return (
    <>
      <PageHeader
        title={title}
        CustomButtons={
          <Button
            sx={{ backgroundColor: "#fff", color: "text.primary", "&:hover": { color: "#fff" } }}
            variant='contained'
            color='primary'
            onClick={() => setModalOpened(true)}>
            Загрузить кандидатов
          </Button>
        }
        mainButtonProps={{
          buttonText: "Создать кандидата",
          onClick: () => navigate("create"),
        }}
      />
      {modalOpened && (
        <AddCandidateModal
          open={modalOpened}
          onClose={() => setModalOpened(false)}
          onSubmit={onSubmitAddCandidateModal}
          submitButtonProps={{ loading: uploadCandidatesLoading }}
          candidatesUploadButton
        />
      )}
    </>
  );
};

export default Header;
